import useSwal from "@tool/Helpers/useSwal";
import {useInertia} from "@tool/Helpers/useInertia";

const templatesManagement = (team_id: string) => {
    useSwal().fire({
        title: 'This functionality requires upgrading to PRO plan.',
        text: 'UTM Templates management is only available in PRO plan. Upgrade your plan to be able to use UTM Templates.',
        showCancelButton: true,
        confirmButtonText: 'Manage your plan',
        icon: 'warning'
    }).then((result) => {
        if (result.isConfirmed) {
            useInertia().get(route('app.team.billing.index', team_id));
        }
    });

}

const shorturlsManagement = (team_id: string) => {
    useSwal().fire({
        title: 'This functionality requires upgrading to PRO plan.',
        text: 'Url Shortening is only available in PRO plan. Upgrade your plan to be able to shorten your urls with one click.',
        showCancelButton: true,
        confirmButtonText: 'Manage your plan',
        icon: 'warning'
    }).then((result) => {
        if (result.isConfirmed) {
            useInertia().get(route('app.team.billing.index', team_id));
        }
    });
}

export default function useRequiresUpgradeAlerts() {
    return {
        templatesManagement,
        shorturlsManagement
    }
}